import { Editor, useEditorState } from '@tiptap/react';
import { FunctionComponent } from 'react';
import { useTranslation } from 'react-i18next';
import { IconLabel } from '../../../IconLabel';

import classNames from 'classnames';
import classes from '../InlineTools.module.scss';

interface UnderlineProps {
  editor: Editor;
}

export const Underline: FunctionComponent<UnderlineProps> = ({ editor }) => {
  const { t } = useTranslation();

  const { isActive, canToggle } = useEditorState({
    editor,
    selector: ({ editor }) => ({
      isActive: editor.isActive('underline'),
      canToggle: editor.can().chain().focus().toggleUnderline().run(),
    }),
  });

  return (
    <IconLabel
      iconId={'underline'}
      iconSize={16}
      ariaLabel={t('richTextEditor.tool-names-underline')}
      onClick={() => editor.chain().focus().toggleUnderline().run()}
      disabled={!canToggle}
      className={classNames(classes['inline-tools__item'], {
        [classes['inline-tools__item--active']]: isActive,
        [classes['inline-tools__item--disabled']]: !canToggle,
      })}
    />
  );
};
